import type { Transcript } from '../../text/Transcript';
import type { TextAlignment } from '../../../enums';
import type { CanvasTextStyleRenderer } from '../../canvasText/renderer/CanvasTextStyle';
import { CanvasLayoutWordMetrics } from '../../canvasText/metrics/CanvasLayoutWordMetrics';
import { generateWordMetricsWhichFitWithinMaxWidth } from '../../canvasText/metrics/CanvasTextMetrics';

export const buildMetricsForCaptions = ({
    transcript,
    alignment,
    style,
    maxWidth,
    maxHeight,
}: {
    transcript: Transcript;
    alignment: TextAlignment;
    style: CanvasTextStyleRenderer;
    maxWidth: number;
    maxHeight: number;
}) => {
    const { wordsWithSpaces, sourceWordReferenceIndices } = transcript.generateWordsFromTranscript();

    const wordMetricsList = generateWordMetricsWhichFitWithinMaxWidth({
        words: wordsWithSpaces,
        highlightAreas: [],
        sourceWordReferenceIndices,
        normalStyle: style,
        highlightStyle: style,
        maxWidth,
        wordWrap: true,
    });

    return CanvasLayoutWordMetrics.layout({
        wordMetricsList,
        alignment: alignment,
        style,
        wordWrap: true,
        wordWrapWidth: maxWidth,
        maxHeight: maxHeight,
        maxLineCount: 1,
        minOccupiedAreaPercentage: 30,
        moveWordsAfterLastPunctuationToNextChunk: true,
        removeTrailingPunctuationOnLastLineFromLastChunk: false,
    });
};
